import Vue from 'vue'
import VueRouter from 'vue-router'
import Genomes from '../pages/Genomes.vue'
import GeneHome from '../pages/GeneHome.vue'
import Genes from '../pages/Genes.vue'
import SequenceServer from '../pages/SequenceServer.vue'
import Species from '../pages/Species.vue'
import TreeResult from '../pages/TreeResult.vue'
import Statistics from '../pages/Statistics.vue'
import SSResult from '../pages/SSResult.vue'
import AboutUs from '../pages/AboutUs.vue'
import Visitors from '../pages/Visitors.vue'
import GeneName from '../pages/GeneName.vue'
import Publication from '../pages/Publication.vue'
import JBrowse from '../pages/JBrowse.vue'
import HeatMapPage from '../pages/HeatMapPage.vue'
import PublicationHome from '../pages/PublicationHome.vue'
import ContactUs from '../pages/ContactUs.vue'
import HeatMapTool from '../pages/HeatMapTool.vue'
import PhylogeneticTree from '../pages/PhylogeneticTree.vue'
const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}



Vue.use(VueRouter)

const routes = [
  {path: '/',redirect: '/GeneHome'},
  {path: '/Genomes',name: 'Genomes',component:Genomes},
  {path: '/GeneHome',name: 'GeneHome',component:GeneHome},
  {path: '/Genes',name: 'Genes',component:Genes},
  {path: '/SequenceServer',name: 'SequenceServer',component:SequenceServer},
  {path: '/Species',name: 'Species',component:Species},
  {path: '/TreeResult',name: 'TreeResult',component:TreeResult},
  {path: '/Statistics',name: 'Statistics',component:Statistics},
  {path: '/SSResult',name: 'SSResult',component:SSResult},
  {path: '/AboutUs',name: 'AboutUs',component:AboutUs},
  {path: '/Visitors',name: 'Visitors',component:Visitors},
  {path: '/GeneName',name: 'GeneName',component:GeneName},
  {path: '/Publication',name: 'Publication',component:Publication},
  {path: '/JBrowse',name: 'JBrowse',component:JBrowse},
  {path: '/HeatMapPage',name: 'HeatMapPage',component:HeatMapPage},
  {path: '/PublicationHome',name: 'PublicationHome',component:PublicationHome},
  {path: '/ContactUs',name: 'ContactUs',component:ContactUs},
  {path: '/HeatMapTool',name: 'HeatMapTool',component:HeatMapTool},
  {path: '/PhylogeneticTree',name: 'PhylogeneticTree',component:PhylogeneticTree},
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
